import {AiBuilderData} from "./aiBuilderData";

export class AiBuilderDataMapper {

  public static map(data: any): AiBuilderData {
    const page: AiBuilderData = new AiBuilderData();
    page.id = typeof data.ID === 'number' ? parseInt(data.ID, 10) : data.ID;
    page.title = data.title;
    page.link = data.url;
    page.modifiedDate = data.post_modified;
    page.postedDate = data.post_date;
    page.createdWith = data.twbb_created_with || data.twbb_imported || data.twbb_blank || data.post_type === 'elementor_library';
    page.conditionCount = data.template_condition_count;
    page.templateType = data.template_type;
    page.pageType = data.post_type;
    page.frontPage = data.page_on_front || false;
    page.kitPage = data.is_ai_kit || null;
    page.kitSettings = data.kit_settings || null;
    page.pageStatus = data.post_status;
    return page;
  }
}
